/* src/components/library-item-filters-with-toggle/library-item-filters-with-toggle.component.scss */
:host {
  display: block;
  position: relative;
  z-index: var(--vwui--zindex--select);
}
.filters-toggle {
  position: relative;
  transform: translateY(0.75rem);
}
.filters-toggle__button {
  float: right;
}
.filters-toggle__button--active {
  --vwui-color-light: var(--vwui-color-neutral-4);
}
.filters-toggle__badge {
  --text: #fff;
  --bg: var(--vwui-color-primary);
  --padding-x: var(--vwui--spacing--xs);
  --padding-y: 0;
  --font-size: 0.8em;
  display: inline-block;
  vertical-align: middle;
  margin: 0 0 0 var(--vwui--spacing--xs);
}
.filters-toggle__content {
  position: absolute;
  z-index: var(--vwui--zindex--select);
  top: calc(var(--vwui-size-spacing-lg) + 2rem);
  right: calc(var(--vwui-size-spacing-xxl) * -1);
  left: calc(var(--vwui-size-spacing-xxl) * -1);
  padding: 0 var(--vwui-size-spacing-xxl);
  overflow: hidden;
  max-height: 0;
  transition:
    max-height 0.4s ease-out,
    padding-top 0.3s ease-out,
    padding-bottom 0.3s ease-out;
  will-change: max-height, padding-top;
  box-sizing: border-box;
  pointer-events: none;
}
.filters-toggle__content--visible {
  max-height: 100vh;
  padding-top: 1rem;
  padding-bottom: var(--vwui-size-spacing-xxl);
  pointer-events: auto;
}
/*# sourceMappingURL=library-item-filters-with-toggle.component-LD5O3LIE.css.map */
